import React, { useEffect, useState } from 'react';
const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [pulsing, setPulsing] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Get the discovery section element
      const discoverySection = document.getElementById('discovery');
      if (discoverySection) {
        // Get the position of the discovery section relative to the viewport
        const discoverySectionPosition = discoverySection.getBoundingClientRect().top;
        // Calculate the middle point of the viewport
        const viewportMiddle = window.innerHeight / 2;
        // Show the button when the discovery section reaches the middle of the screen
        if (discoverySectionPosition <= viewportMiddle) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      }
    };
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    // Set up pulsing animation at intervals
    const pulseInterval = setInterval(() => {
      setPulsing(true);
      setTimeout(() => setPulsing(false), 2000);
    }, 10000);
    // Initial check in case the page loads already scrolled to the section
    handleScroll();
    // Clean up event listeners
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(pulseInterval);
    };
  }, []);
  return <div className={`fixed bottom-0 left-0 w-full p-2 bg-white shadow-lg border-t border-gray-200 z-50 transition-all duration-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`} data-id="element-453">
      <div className="max-w-lg mx-auto" data-id="element-454">
        <div className="flex items-center mb-1 justify-between px-2" data-id="element-455">
          <div className="flex items-center" data-id="element-456">
            <div className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse" data-id="element-457"></div>
            <p className="text-sm text-gray-600 font-medium" data-id="element-458">
              487 patches left at this price
            </p>
          </div>
          <p className="text-sm text-red-600 font-bold" data-id="element-459">Offer ends soon!</p>
        </div>
        <a href="https://myoquell.com/products/escape-knee-pain-with-myoquell-herbal-patches" className={`bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white font-bold py-3 px-6 rounded-lg w-full text-lg block text-center transition-all shadow-md ${pulsing ? 'animate-pulse scale-105' : ''}`} target="_blank" rel="noopener noreferrer" data-id="element-460">
          CLAIM YOUR DISCOUNTED MYOQUELL NOW →
        </a>
      </div>
    </div>;
};
export default StickyCTA;